import React, { useState } from 'react';
import { connect } from 'react-redux';
import { InfoBox, Marker } from '@react-google-maps/api';
import { MarkerWithLabelIcon } from 'components/map';
import { displayedPostAcqValuationSelector, displayedValuationSelector } from 'store/selectors';
import { setPostAcqPropertyGridRowIdToFocus, setPropertyGridRowIdToFocus } from 'store/actions';
import isEqual from 'lodash/isEqual';
import { Constants } from 'utilities/constants';

function areEqual(prevProps, nextProps) {
  return isEqual(prevProps, nextProps);
}

const MarkerWrapper = ({ map, selectedMarker, setSelectedMarker, selectedMarkerLabel, drawIsOn, autoNav, toggleIsSelectedAsComp,
  uwType, marker, selectedMarkerImages, isFetchingImages, images, iconColor, iconType, gridCurrentViewData, selectionEnabled,
  isCaptured = true, isStreetView, isSelectedAsComp, setPropertyGridRowIdToFocus }) => {
  const [isHovered, setIsHovered] = useState(false);

  const selectedMarkerId = selectedMarker?.id || selectedMarker?.asgCompPropertyId;
  const markerId = marker?.id || marker?.asgCompPropertyId;
  const toggleIsHovered = (isHovered) => {
    if (!marker?.asgCompPropertyId) {
      setIsHovered(isHovered);
    }
  }
  const onClick = e => {
    e.stopImmediatePropagation();
    if (e.target == null) {
    } else if (e.ctrlKey) {
      // get street view with ctrl + click
      map.getStreetView().setOptions({ visible: true, position: { lat: marker.latitude, lng: marker.longitude } });
    } else if (e.target.type !== 'checkbox' && e.target.tagName !== 'path' && e.target.tagName !== 'svg' && e.target.tagName !== 'IMG') {//somehow DOM doesn't update on hover, so it will be detected as the house image
    setSelectedMarker(marker);// this action will trigger the fetching of images in getImagesSaga
    setPropertyGridRowIdToFocus(markerId);
    } else {
      if (!marker.isSubject && toggleIsSelectedAsComp) {
        toggleIsSelectedAsComp(marker.id);
      }
      setSelectedMarker(marker);// this action will trigger the fetching of images in getImagesSaga
      setPropertyGridRowIdToFocus(markerId);
    }
  }

  function hoverOn() {
    if (!marker.isSubject) {
      toggleIsHovered(true);
    }
  }

  function hoverOff() {
    if (!marker.isSubject) {
      toggleIsHovered(false);
    }
  }

  function onLoad(infobox) {
    infobox.addListener('domready', function() {
      infobox.div.addEventListener('mouseenter', hoverOn);
      infobox.div.addEventListener('mouseleave', hoverOff);
      infobox.div.addEventListener('click', onClick);
    });
  }

  function onUnmount(infobox) {
    if (infobox?.div) {
      infobox.div.removeEventListener('mouseenter', hoverOn);
      infobox.div.removeEventListener('mouseleave', hoverOff);
      infobox.div.removeEventListener('click', onClick);
    }
  }

  // Handling for comps in propertyUW vs txnOpps in auctionUW - comps use livingArea field from GUD
  const sqft = marker.livingArea || marker.sqft;
  let label;
  switch (selectedMarkerLabel) {
    case 'yearBuilt':
      label = marker.yearBuilt ? marker.yearBuilt : '';
      break;
    case 'beds':
      label = marker.beds ? marker.beds.toFixed(1) : '';
      break;
    case 'baths':
      label = marker.baths ? marker.baths.toFixed(1) : '';
      break;
    case 'sqft':
      label = sqft ? (sqft).toLocaleString(undefined, { maximumFractionDigits: 0 }) : '';
      break;
    case 'rentprice':
      label = marker.price ? `$${marker.price.toLocaleString(undefined, { maximumFractionDigits: 0 })}` : '';
      break;
    case 'rentpricesqft':
      label = marker.price && sqft && sqft !== 0 ?
        `$${(marker.price / sqft).toFixed(2)}` : '';
      break;
    case 'schoolScore':
      label = marker.schoolScoreAverage ? marker.schoolScoreAverage : '';
      break;
    case 'region':
      label = marker.region ? marker.region : '';
      break;
    case 'ctMedIncome':
      label = marker.amherstEstimatedAMI ? `$${marker.amherstEstimatedAMI.toLocaleString(undefined, { maximumFractionDigits: 0 })}` : '';
      break;
    case 'rentValue':
      label = marker.rentValue ? `$${marker.rentValue.toLocaleString(undefined, {maximumFractionDigits: 0 })}` : '';
      break;
    default:
      label = '';
      break;
  }
  const isSelected = selectedMarker && (selectedMarkerId === markerId);
  //console.log('selectedMarker in MarkerWrapper', selectedMarker);
  let anchor;
  if (marker.isSubject) { //TODO: isSubject logic for post-DTO change 12/4/19
    anchor = isSelected ? new window.google.maps.Point(12, 42) : new window.google.maps.Point(8, 36);    // offset the subject property up a bit since the icon size is a bigger
  } else {
    anchor = isSelected ? new window.google.maps.Point(11, 36) : new window.google.maps.Point(8, 28);    // offset the needle to point to the actual location
  }
  // const markerLabelClass = `markerWithLabelWrapper ${drawIsOn ? (marker.captured ? 'captured' : 'notCaptured') : (marker.captured ? 'captured' : 'notCaptured')}`;
  // Check if the marker is in grid current view data (used for double filtering grid and map drawing)
  const isMarkerInCurrentViewData = gridCurrentViewData && gridCurrentViewData.some(g => g === markerId);
  const markerLabelClass = `markerWithLabelWrapper ${isMarkerInCurrentViewData && isCaptured ? 'captured' : 'notCaptured'}`;

  const houseSvg = {
    path: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z",
    fillColor: (uwType === 'auctionUW' && !isSelected) ? 'yellow' : 'orange',
    fillOpacity: 1,
    anchor: new window.google.maps.Point(10, 10),
    strokeWeight: 0,
    scale: 2
  }
  if (!marker.latitude || !marker.longitude) return null;
  return (
    isStreetView && (marker.isSubject || uwType === 'auctionUW')
      ? <Marker
          position={{ lat: marker.latitude, lng: marker.longitude }}
          icon={houseSvg}
        />
      : <>
        {/* <MarkerWithLabel
          key={marker.id}
          labelClass={markerLabelClass}
          labelAnchor={anchor}
          position={{ lat: marker.latitude, lng: marker.longitude }}
          icon={isStreetView && (marker.isSubject || uwType === 'auctionUW') ? houseSvg : { url: transparentMarker }}
          onClick={onClick}
          zIndex={marker.isSubject ? 9 : selectedMarker && selectedMarkerId === markerId ? 10 : 1}
          onMouseOver={!marker.isSubject ? () => toggleIsHovered(true) : null}
          onMouseOut={!marker.isSubject ? () => toggleIsHovered(false) : null}
        > */}
        <InfoBox
          position={{ lat: marker.latitude, lng: marker.longitude }}
          zIndex={marker.isSubject ? 9 : selectedMarker && selectedMarkerId === markerId ? 10 : 1}
          options={{
            boxClass: markerLabelClass,
            boxStyle: {
              overflow: 'hidden'
            },
            closeBoxURL: ``,
            // enableEventPropagation: true,
            pane: 'overlayMouseTarget',
            pixelOffset: {
              width: -anchor.x,
              height: -anchor.y
            },
            disableAutoPan: true
          }}
          onLoad={onLoad}
          onUnmount={onUnmount}
        >
          <MarkerWithLabelIcon
            isSelected={isSelected}
            isSubject={marker.isSubject}
            isSelectedAsComp={isSelectedAsComp}
            isTerminated={marker ? marker.status === 'Terminated' : false}
            label={label}
            isHovered={isHovered}
            selectedMarkerImages={selectedMarkerImages}
            isFetchingImages={isFetchingImages}
            images={images}
            selectionEnabled={selectionEnabled}
            iconColor={iconColor}
            iconType={iconType}
            uwType={uwType}
            id={markerId}
            // setMarkerLabelHeight={setMarkerLabelHeight}
          />
        </InfoBox>
      </>
  )
}

const mapStateToProps = (state, ownProps) => {
  const displayedValuation = ownProps.module === Constants.Module.POSTACQ ? displayedPostAcqValuationSelector(state, ownProps.viewingReadonlyMode) : displayedValuationSelector(state);
  if (ownProps.uwType !== 'msrHome') {
    const isSelectedAsComp = displayedValuation?.valuationsComps?.find(vc => vc.compId === ownProps.marker.id) != null;
    return {
      isSelectedAsComp
    }
  } else {
    return { }
  }
};

const mapDispatch = (dispatch, ownProps) => {
  const actions = ownProps.module === Constants.Module.POSTACQ
    ? {
      setPropertyGridRowIdToFocus: setPostAcqPropertyGridRowIdToFocus
    }
    : {
      setPropertyGridRowIdToFocus
    };
  return {
    setPropertyGridRowIdToFocus: rowId => dispatch(actions.setPropertyGridRowIdToFocus(rowId, ownProps.viewingReadonlyMode))
  }
};

export default connect(mapStateToProps, mapDispatch)(React.memo(MarkerWrapper, areEqual));
